import React from 'react';

const Navigation = ({ activeSection, onSectionChange, isLoggedIn, onLogin, onLogout }) => {
  return (
    <div className="navbar">
      <div className="navbar-brand">
        <h1>Server Control</h1>
      </div>
      <div className="navbar-menu">
        {isLoggedIn ? (
          <>
            <button 
              className={`nav-button ${activeSection === 'servers' ? 'active' : ''}`}
              onClick={() => onSectionChange('servers')}
            >
              Servers
            </button>
            <button 
              className={`nav-button ${activeSection === 'contacts' ? 'active' : ''}`}
              onClick={() => onSectionChange('contacts')}
            >
              Contacts Tester
            </button>
            <button 
              className={`nav-button ${activeSection === 'test-data' ? 'active' : ''}`}
              onClick={() => onSectionChange('test-data')}
            >
              Saved Messages
            </button>
            <button 
              className={`nav-button ${activeSection === 'predictor' ? 'active' : ''}`}
              onClick={() => onSectionChange('predictor')}
            >
              Predictor Test
            </button>
            <button 
              className={`nav-button ${activeSection === 'vessel' ? 'active' : ''}`}
              onClick={() => onSectionChange('vessel')}
            >
              VesselIMO
            </button>
            <button className="nav-button logout" onClick={onLogout}>
              Logout
            </button>
          </>
        ) : (
          <button className="nav-button login" onClick={onLogin}>
            Login
          </button>
        )}
      </div>
    </div>
  );
};

export default Navigation; 